import React, { useEffect, useState } from "react";
import "./styles.scss";
import { useNavigate } from "react-router-dom";

import { Select, MenuItem } from "@mui/material";
import { Button } from "@mui/material";

const Products = (props) => {
  const {
    item,
    index,
    handleSelectedVariant,
    handleDefaultVariant,
    className,
  } = props;
  const [selectedAttribute, setSelectedAttribute] = useState([]);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [selectedObject, setSelectedObject] = useState({});
  const [selectedToken, setSelectedToken] = useState("");
  const Navigate = useNavigate();

  useEffect(() => {
    if (item?.variants?.length && selectedAttribute?.length) {
      let tempSeletecVariant = [];
      item.variants.map((variant) => {
        let isFound = null;
        variant?.variation_attributes?.length &&
          variant.variation_attributes.map((variantAttribute) => {
            if (
              isFound !== false &&
              selectedAttribute.includes(variantAttribute?.option_name)
            ) {
              isFound = true;
            } else {
              isFound = false;
            }
          });
        if (isFound) {
          tempSeletecVariant.push({
            ...variant,
            // variation_attributes: null,
          });
        }
      });
      if (tempSeletecVariant?.length === 1) {
        setSelectedVariant({ ...tempSeletecVariant[0] });
      } else {
        setSelectedVariant(null);
      }
    } else {
      setSelectedVariant(null);
    }
  }, [selectedAttribute]);

  useEffect(() => {
    if (selectedVariant !== null) {
      if (selectedToken === "loaded") {
        handleDefaultVariant({ index, selectedVariant });
        setSelectedToken("");
      } else {
        handleSelectedVariant({ index, selectedVariant });
      }
    }
  }, [selectedVariant]);

  useEffect(() => {
    const objKeys = Object.keys(selectedObject);
    if (objKeys?.length) {
      const arr = [];
      objKeys.map((keyValue) => {
        if (selectedObject?.[keyValue]) {
          arr.push(selectedObject[keyValue]);
        }
      });
      setSelectedAttribute(arr);
    }
  }, [selectedObject]);

  useEffect(() => {
    const objKeys = Object.keys(selectedObject);
    if (objKeys?.length === 0 && item?.attributes) {
      let temp = {};
      setSelectedToken("loaded");
      Object.entries(item.attributes).map(([category, options]) => {
        if (options?.length) {
          temp[category] = options[0]?.option_name;
        }
      });
      setSelectedObject(temp);
    }
  }, []);

  return (
    <div className={className}>
      <div className="product-section">
        <div
          className="image"
          onClick={() => {
            sessionStorage.setItem("product_index", index);
            Navigate(`${process.env.REACT_APP_BASE}/product-details`);
          }}
        >
          <img
            src={
              selectedVariant !== null
                ? selectedVariant?.variation_image
                : item?.product_image
            }
            alt={`products ${index}`}
          />
        </div>
        <div className="product-detail">
          <h3
            onClick={() => {
              sessionStorage.setItem("product_index", index);
              Navigate(`${process.env.REACT_APP_BASE}/product-details`);
            }}
          >
            {item?.product_name}
          </h3>
          {Object.entries(item?.attributes)?.map(([category, options]) => {
            return (
              <div key={category} className="selection">
                {/* image attribute */}
                {(category?.split("__")[1] === "image" ||
                  category?.split("__")[1] === "") && (
                  <>
                    <h2>
                      {category?.split("__")[0]}:{" "}
                      <span className="selected-value">
                        {selectedObject?.[category]}
                      </span>
                    </h2>
                    <div className="accessory">
                      {options?.map((option) => (
                        <p key={option.option_name} className="accessory-image">
                          {option?.option_image && (
                            <img
                              className={`${
                                selectedObject?.[category] ===
                                option?.option_name
                                  ? "active"
                                  : ""
                              }`}
                              src={option?.option_image}
                              alt={option?.option_name}
                              onClick={() => {
                                const temp = { ...selectedObject };
                                temp[category] = option?.option_name;
                                setSelectedObject(temp);
                              }}
                            />
                          )}
                        </p>
                      ))}
                    </div>
                  </>
                )}
                {/* color attribute */}
                {category?.split("__")[1] === "color" && (
                  <>
                    <h2>
                      {category?.split("__")[0]}:{" "}
                      <span className="selected-value">
                        {selectedObject?.[category]}
                      </span>
                    </h2>
                    <div className="accessory">
                      {options?.map((option) => {
                        return (
                          <p key={option.color} className="accessory-image">
                            {option?.color && (
                              <p
                                className={`${
                                  selectedObject?.[category] ===
                                  option?.option_name
                                    ? "active"
                                    : ""
                                }`}
                                style={{
                                  backgroundColor: option?.color,
                                  padding: "18px",
                                  borderRadius: "50px",
                                  boxShadow: "inset 0 0 5px #cdcbcb",
                                }}
                                onClick={() => {
                                  const temp = { ...selectedObject };
                                  temp[category] = option?.option_name;
                                  setSelectedObject(temp);
                                }}
                              ></p>
                            )}
                          </p>
                        );
                      })}
                    </div>
                  </>
                )}

                {/* dropdown attribute */}
                {category?.split("__")[1] === "select" && (
                  <>
                    <h2>{category?.split("__")[0]}</h2>
                    <div className="accessory">
                      <Select
                        labelId="simple-select-label"
                        id="simple-select"
                        value={
                          selectedObject?.[category]
                            ? selectedObject?.[category]
                            : ""
                        }
                        placeholder="Choose an option"
                        className="auto-dropdown"
                        onChange={(event) => {
                          const temp = { ...selectedObject };
                          temp[category] = event.target?.value;
                          setSelectedObject(temp);
                        }}
                      >
                        {options?.map((option) => {
                          return (
                            <MenuItem value={option?.option_name}>
                              {option?.option_name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </div>
                  </>
                )}

                {/* button attribute */}
                {category?.split("__")[1] === "button" && (
                  <>
                    <h2>
                      {category?.split("__")[0]}:{" "}
                      <span className="selected-value">
                        {selectedObject?.[category]}
                      </span>
                    </h2>
                    <p className="btn-attribute">
                      {options?.map((option) => {
                        return (
                          <>
                            {option?.option_name && (
                              <Button
                                className={`${
                                  selectedObject?.[category] ===
                                  option?.option_name
                                    ? "active"
                                    : ""
                                }`}
                                onClick={() => {
                                  const temp = { ...selectedObject };
                                  temp[category] = option?.option_name;
                                  setSelectedObject(temp);
                                }}
                              >
                                {option?.option_name}
                              </Button>
                            )}
                          </>
                        );
                      })}
                    </p>
                  </>
                )}
              </div>
            );
          })}
          <div className="btn">
            <Button
              onClick={() => {
                sessionStorage.setItem("product_index", index);
                Navigate(`${process.env.REACT_APP_BASE}/product-details`);
              }}
            >
              Learn more
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Products;
